import { Preferences } from "@capacitor/preferences";
import type { KeyValueStorage } from "./storage";

export const capacitorPreferencesAdapter: KeyValueStorage = {
  async get(key) {
    const { value } = await Preferences.get({ key });
    return value;
  },
  async set(key, value) {
    await Preferences.set({ key, value });
  },
  async remove(key) {
    await Preferences.remove({ key });
  },
};
